import React from 'react';
import TopNav from './TopNav';
import Footer from './Footer';
import useSEO from '../hooks/useSEO';

function InternalizingFragilityPaperPage({ logo }) {
  useSEO({
    title: 'Internalizing Fragility in Triple Bottom Line Supply Chains',
    description:
      'Full paper coming soon: a system dynamics approach to quantifying non-linear risk in triple bottom line supply chains.',
    noIndex: true
  });

  return (
    <div className="min-h-screen bg-white">
      <TopNav logo={logo} />

      <main className="max-w-4xl mx-auto px-8 py-16 md:py-24">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-[0.2em] mb-4">
          Full Paper Coming Soon
        </p>

        <h1 className="text-3xl md:text-4xl font-medium text-gray-900 leading-tight tracking-tight mb-6">
          Internalizing Fragility in Triple Bottom Line Supply Chains
        </h1>

        <p className="text-sm text-gray-600 leading-relaxed mb-5">
          Internalizing Fragility: A System Dynamics Approach to Quantifying Non-Linear Risk in Triple Bottom Line Supply Chains
        </p>

        <p className="text-sm text-gray-600 mb-8">
          <span className="font-medium text-gray-900">Context:</span> Corresponding paper for the Fall 2026 workshop game, The Anti-Fragile Nexus.
        </p>

        <section className="bg-gray-50 border border-gray-200 rounded-xl p-6 md:p-8">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Core Thesis Summary</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Most operational risk methods treat disruption as exogenous, focusing on events outside the firm. This paper argues that fragility is
            also endogenous: organizations can accumulate a measurable stock of risk through repeated short-term optimization.
          </p>
          <ul className="space-y-2 text-gray-700 text-sm leading-relaxed">
            <li>Defines fragility as a buildable stock, not just an external probability.</li>
            <li>Shows how People and Planet buffers function as protective capacity in Triple Bottom Line systems.</li>
            <li>Explains how cost or efficiency decisions can silently create non-linear downside through delayed systemic effects.</li>
          </ul>
        </section>

        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href="/anti-fragile-nexus"
            className="inline-flex items-center justify-center border border-gray-300 text-gray-700 px-6 py-3 rounded text-sm font-medium hover:border-gray-400 hover:text-gray-900 transition-colors"
          >
            View Related Workshop Page
          </a>
          <a
            href="/contact"
            className="inline-flex items-center justify-center bg-gray-900 text-white px-6 py-3 rounded text-sm font-medium hover:bg-gray-800 transition-colors"
          >
            Contact for Details
          </a>
        </div>
      </main>

      <Footer logo={logo} />
    </div>
  );
}

export default InternalizingFragilityPaperPage;